import React, { FC } from 'react';
import { amount, format } from '@aml/amount';
import { BigNumber } from 'bignumber.js';
import { CardItem, ListItem } from '@shared/ui';
import { LoaderOverlay } from '@rubin-dev/goblin';
import { BalanceTooltip } from './BalanceTooltip';
import { useTranslation } from 'react-i18next';

type BalanceCardProps = {
  network: string;
  total: number;
  totalIn: number;
  totalOut: number;
  loading?: boolean;
};
export const BalanceCard: FC<BalanceCardProps> = ({
  network,
  total,
  totalIn,
  totalOut,
  loading,
}) => {
  const { t } = useTranslation();
  const formatBalance = (val?: number) =>
    Number(val) > 0 ? amount(BigNumber(val || 0).toString(10), network, false) : 0;
  const totalFormat = format(parseFloat(String(total)).toFixed(2), 2);
  const totalInFormat = formatBalance(totalIn);
  const totalOutFormat = formatBalance(totalOut);

  return (
    <CardItem
      rightSlot={
        <BalanceTooltip
          totalIn={String(totalInFormat)}
          totalOut={String(totalOutFormat)}
        />
      }
    >
      <LoaderOverlay show={loading} />
      <ListItem label={`${t('strings.balance')}:`} value={String(totalFormat)} />
    </CardItem>
  );
};
